module.exports = __webpack_public_path__ + "static/img/google-play.fdca4bcb.svg";